module.exports = __webpack_public_path__ + "static/media/faq.3d5131fc.png";